import imgSrc from '../javascripts/imgSrc'
let pt = {
  postureHome: {
    indexPage: {
      a_posture_title: 'Relatório postural',
      show: '1'
    },
    coverInfo: {
      customerName: 'Paciente/Cliente',
      date: 'Data do teste',
      time: 'Hora do teste',
      userName: 'Profissional',
      clickEnterReport: 'Acessar relatório'
    }
  },
  postureIpad: {
    bullet: {
      Home: 'Casa',
      Posturedata: 'Dados da postura',
      Score: 'Avaliação de risco',
      Muscle: 'Avaliação muscular',
      Solution: 'Solução'
    },
    front: 'Coronal',
    side: 'Sagital',
    viwesNav: 'Sagital | Coronal',
    InvalidData: 'Relatório invalido',
    qrcode: 'Enviamos um email para desbloquear seu exercício',
    expertsWalk: 'Senno Postura',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Clique no botão no canto superior direito',
    clickTranspond: 'Clique para compartilhar o mini programa',
    symptoms: {
      head: [
        {
          name: 'Inclinação da cabeça',
          key: 'headSidesway',
          normal: {
            left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle:
              '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des:
              '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [
            {
              name: 'Tensão crônica dos músculos e ligamentos',
              des:
                'A inclinação cefálica prolongada ou torcicolo pode levar a tensão crônica do ligamento cervical Posterior e dos músculos circundantes. '
            },
            {
              name: 'Espondilose cervical',
              des:
                'A região cervical é formada por sete vértebras, conectadas entre se, por ligamentos e envolvida por músculos que suportam o peso da cabeça. A espondilose cervical é a degeneração das vértebras e dos discos intervertebrais, exercendo compressão sobre a medula espinhal no nível do pescoço. A dor nesta região, muitas vezes é atribuída ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição anormal dos tecidos moles e dos ossos de uma cabeça ectópica (desalinhada) aumenta o risco de dor e degeneração óssea e dos discos intervertebrais.'
            }
          ]
        },
        {
          name: 'Cabeça para Coronal',
          key: 'headLean',
          normal: {
            normal: imgSrc.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle:
              '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular:
              '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des:
              '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [
            {
              name: 'Tonturas e dores de cabeça',
              des:
                'Hipóxia cerebral causada por má circulação resultante da postura com a Protusao. de cabeca, pode levar a tonturas e dores de cabeça.'
            },
            {
              name: 'Espondilose cervical',
              des:
                'O pescoço é um conjunto de 7 vertebras conectadas por ligamentos e envolvidas por músculos que suportam um peso de 50 kg - sua cabeça! A dor no pescoço é um problema doloroso muitas vezes atribuído ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição normal dos tecidos moles e dos ossos de uma cabeça ectópica aumenta o risco de degeneração dolorosa dos discos intervertebrais'
            }
          ]
        }
      ],
      shoulder: [
        {
          name: 'Ombros desalinhados',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle:
              '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des:
              '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [
            {
              name: 'Dor crônica de cabeça',
              des:
                ' Ombros irregulares podem eventualmente levar a dores de cabeça crônicas.'
            },
            {
              name: 'Esporão ósseo',
              des:
                ' Ombros que não estão nivelados geram força anormal no pescoço, tornando uma pessoa propensa a degeneração da coluna cervical e, em alguns casos, osteófitos (Bico de papagaio). '
            },
            {
              name: 'Lombalgia',
              des:
                ' Ombros inclinados podem causar inclinação lateral da pelve, desequilíbrio muscular da cintura e lombalgia.'
            },
            {
              name: 'Discrepância no comprimento dos membros inferiores',
              des:
                ' A inclinação lateral da pélve, também aumenta o risco de uma aparente discrepância de membros inferiores.'
            }
          ]
        },
        {
          name: 'Protusão de ombros',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.ROUND_SHOULDER
          },
          definition:
            '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des:
              '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [
            {
              name: 'Doença cardiovascular',
              des:
                'Ombros Rounded tornam o diafragma tenso, aumentando o risco de doença cardiovascular.'
            },
            {
              name: 'Dores de cabeça',
              des:
                ' A tensão no pescoço e nos músculos que circundam os ombros, pode até causar compressão do nervo cervical e provocar dores de cabeça.'
            },
            {
              name: 'Parestesia (dormência) dos braços',
              des:
                ' A compressão do nervo cervical também pode causar dormência ou parestesia dos braços.'
            }
          ]
        }
      ],
      trunk: [
        {
          name: 'Escoliose',
          key: 'spineSidesway',
          normal: {
            left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition:
            '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des:
              '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [
            {
              name: 'Escoliose',
              des:
                'Uma inspeção 3D, ou um raio x panorâmico são indicados para diagnosticar a escoliose.'
            },
            {
              name: 'Ombros desalinhados',
              des:
                'A escoliose pode ser acompanhada de desalinhamento dos ombros'
            },
            {
              name: 'Desalinhamento do quadril',
              des:
                'A escoliose pode ser acompanhada de desalinhamento do quadril.'
            }
          ]
        }
      ],
      pelvis: [
        {
          name: 'Desalinhamento do quadril',
          key: 'pelvisLean',
          normal: {
            left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition:
            '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle:
              '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des:
              '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [
            {
              name: 'Dor crônica',
              des:
                'O desalinhamento do quadril, pode causar dor nas extremidades.'
            },
            {
              name: 'Hérnia de disco lombar',
              des:
                'O desalinhamento do quadril, pode aumentar o risco de hérnia de disco lombar.'
            },
            {
              name: 'Discrepância do comprimento da perna',
              des:
                ' Desalinhamento do quadril pode aumentar o risco de discrepância no comprimento das pernas.'
            }
          ]
        }
      ],
      'lower extremity': [
        {
          name: 'Joelho varo',
          key: 'legO',
          normal: {
            normal: imgSrc.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_O
          },
          definition:
            '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des:
              '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [
            {
              name: 'Lesão no menisco',
              des:
                'A força no membro inferior dos indivíduos com pernas arqueadas, é alterada para que'
            },
            {
              name: 'Artrites',
              des:
                'Pernas arqueadas podem eventualmente evoluir para osteoartrite no espaço intersticial lateral da articulação.'
            }
          ]
        },
        {
          name: 'Genu Valgo',
          key: 'legX',
          normal: {
            normal: imgSrc.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle:
              '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des:
              '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [
            {
              name: 'Lesão no menisco',
              des:
                'Os joelhos valgos alteram a direção da força nos membros inferiores, o joelho fica sujeito ao aumento da pressão lateral. Lesões e distensão laterais do menisco geralmente resultam.'
            },
            {
              name: 'Artrites',
              des:
                'O Genu valgo severo, pode eventualmente progredir para osteoartrite.'
            }
          ]
        },
        {
          name: 'Joelho recurvato',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition:
            '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle:
              '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des:
              '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [
            {
              name: 'Degeneração da articulação do joelho',
              des:
                'Desgaste excessivo e degeneração do joelho é o resultado de genu recurvato persistente.'
            },
            {
              name: 'Influência do equilíbrio corporal',
              des:
                'Joelhos deformados levam a mudanças de posição dos quadril, pelve e tornozelos, e podem modificar gradualmente o equilíbrio de todo o corpo.'
            }
          ]
        },
        {
          name: 'Pernas com arco falso',
          key: 'legXO',
          normal: {
            normal: imgSrc.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des:
              'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [
            {
              name: 'Dor no joelho',
              des:
                'Quando a pelve se inclina para Coronal, cria também um desalinhamento da “grid” na articulação do joelho. Seu fêmur não desliza corretamente sobre a tíbia (Osso da canela), criando um desequilíbrio. Quando este desequilíbrio é combinado com rotações interna do fêmur (devido à fraqueza de glúteos por causa do APT), pode ocorrer perfeitamente uma curvatura falsa dos joelhos.\n' +
                'Você pode ouvir seu joelho, estalar e rangir com freqüência durante sua movimentação ao longo do dia. '
            },
            {
              name: 'Artrites',
              des:
                'À medida que o tempo avança, você pode começar a sentir dor, já que as estruturas estabilizadoras (cartilagem e ligamentos) do joelho são desgastadas a uma taxa muito mais rápida em comparação com um joelho neutro.'
            }
          ]
        }
      ]
    }
  },
  postureModalIpad: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco médio',
    heightRisk: 'Risco alto',
    suggest:
      ' Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis ',
    suggestSolve:
      ' Você realmente precisam melhorar sua postura, procure  um fisioterapeuta especialista em quiropraxia, osteopatia ou podoposturologia para fazer mais avaliações',
    normal: 'Normal',
    risk: 'Risco',
    return: 'Retorno',
    levelName: 'Alto | Médio | Baixo'
  },
  postureModal: {
    normal: 'Normal',
    highRisk: 'Risco alto',
    goback: 'Posterior',
    potentialRisk: 'Risco médio',
    levelName: 'Alto | Médio | Baixo',
    symptominterpretation: 'Dicas',
    triggersymptoms: 'Impactos'
  },
  postureReport: {
    redAlert: ' Zona vermelha significa tensão muscular ',
    yellowAlert: ' Zona amarela significa fraqueza muscular',
    muscleDire: {
      normal: 'Normal',
      face: 'Coronal',
      side: 'Sagital',
      back: 'Posterior'
    },
    details: {
      lh: 'lh',
      ll: 'll',
      rh: 'rh',
      rr: 'rr'
    },
    descripName: {
      upName: 'precisa ser fortalecido',
      lowName: 'precisa ser alongado'
    },
    navList: 'Coronal | Sagital | Posterior',
    boneDescription: {
      face: {
        trunk: 'Músculos abdutores',
        legForX: [
          'Músculos abdutores do quadril',
          'Músculos adutores do quadril,'
        ],
        legForO: 'Músculos abdutores do quadril',
        legForStretch: 'Quadriceps femoral',
        round: 'Peitoral maior'
      },
      side: {
        round: 'O músculo esternocleidomastoideo,',
        fore: 'O músculo esternocleidomastoideo, ',
        shoulder: 'Músculo Escaleno'
      },
      back: {
        spine: 'Trapézio superior',
        shoulder: 'Trapézio superior',
        round: ['Trapézio superior', 'Trapézio inferior'],
        fore: ['Trapézio superior', 'Trapézio inferior'],
        rake: 'Levantador da escápula,',
        legStretch: ['Músculos isquiotibiais', 'Fascia plantar'],
        legX: ['Glúteos máximo,médio e minimo', 'Biceps femoral'],
        // TODO invetors -> Tibialis Anterior ；Tibialis Posterior，需要匈牙利语翻译
        legO: ['Isquiotibiais', 'Invetors'],

        legXO: ['Biceps femoral', 'Fascia Plantar']
      }
    }
  },
  postureSymp: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco médio',
    heightRisk: 'Risco alto',
    suggest:
      'Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis',
    suggestSolve:
      'Você realmente precisam melhorar sua postura, procure um fisioterapeuta especialista em quiropraxia, osteopatia ou em podoposturologia para fazer mais avaliações',
    normal: 'Normal',
    risk: 'Risco'
  },
  postureSympIpad: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco médio',
    heightRisk: 'Risco alto',
    suggest:
      'Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis',
    suggestSolve:
      'Você realmente precisam melhorar sua postura, procure um fisioterapeuta especialista em quiropraxia, osteopatia ou em podoposturologia para fazer mais avaliações',
    normal: 'Normal',
    risk: 'Risco'
  },
  posture: {
    bullet: {
      Home: 'Casa',
      Posturedata: 'Dados da Postura',
      Score: 'Avaliação de risco',
      Muscle: 'Avaliação Muscular',
      Solution: 'Solução'
    },
    viwesNav: 'Sagital | Coronal',
    InvalidData: 'Relatório inválido',
    qrcode: 'Envie-nos um email para desbloquear seu exercício',
    expertsWalk: 'Senno Postura',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Clique no botão no canto superior direito',
    clickTranspond: 'Clique para compartilhar o mini programa',
    symptoms: {
      head: [
        {
          name: 'Inclinar a cabeça',
          key: 'headSidesway',
          normal: {
            left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle:
              '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des:
              '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [
            {
              name: 'Tensão crônica dos músculos e ligamentos',
              des:
                'A inclinação cefálica prolongada ou torcicolo, pode levar a tensão crônica do ligamento cervical Posterior e dos músculos circundantes. '
            },
            {
              name: 'Espondilose cervical',
              des:
                'O pescoço é um conjunto de 7 vertebras conectados por ligamentos e envolvidas por músculos que suportam um peso de 7 kg - sua cabeça! A dor no pescoço é um problema doloroso muitas vezes atribuído ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição normal dos tecidos moles e dos ossos de uma cabeça ectópica aumenta o risco de degeneração dolorosa dos discos intervertebrais'
            }
          ]
        },
        {
          name: 'Protusão de cabeça',
          key: 'headLean',
          normal: {
            normal: imgSrc.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle:
              '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular:
              '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des:
              '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [
            {
              name: 'Tonturas e dores de cabeça',
              des:
                'Hipóxia cerebral causada por má circulação resultante da postura com a Protusao de cabeca pode levar a tonturas e dores de cabeça.'
            },
            {
              name: 'Espondilose Cervical',
              des:
                'O pescoço é um conjunto de 7 vertebras conectadas por ligamentos e envolvidas por músculos que suportam um peso de 50 kg - sua cabeça! A dor no pescoço é um problema doloroso muitas vezes atribuído ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição normal dos tecidos moles e dos ossos de uma cabeça ectópica aumenta o risco de degeneração dolorosa dos discos intervertebrais'
            }
          ]
        }
      ],
      shoulder: [
        {
          name: 'Ombros desalinhados',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle:
              '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des:
              '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [
            {
              name: 'Dores de cabeça crônica',
              des:
                'Ombros desalinhados podem eventualmente, levar a dores de cabeça crônica.'
            },
            {
              name: 'Osteófitos',
              des:
                ' Ombros desalinhados geram força anormal no pescoço, tornando uma pessoa propensa a degeneração da coluna cervical em alguns casos, osteófitos. '
            },
            {
              name: 'Lombalgia',
              des:
                'Ombros desalinhados(elevaldo ou deprimido) podem causar inclinação lateral da pelve, desequilíbrio muscular da cintura e lombalgia.'
            },
            {
              name: 'Discrepância no comprimento dos membros inferiores',
              des:
                'A inclinação lateral da pelve, também aumenta o risco de uma aparente desigualdade no comprimento das pernas.'
            }
          ]
        },
        {
          name: 'Protusão de ombros',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.ROUND_SHOULDER
          },
          definition:
            '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des:
              '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [
            {
              name: 'Doença Cardiovascular',
              des:
                'Ombros protusos tornam o diafragma tenso, aumentando o risco de doença cardiovascular.'
            },
            {
              name: 'Dores de cabeça',
              des:
                ' A tensão no pescoço e nos músculos que circundam os ombros pode  causar compressão do nervo cervical e dores de cabeça.'
            },
            {
              name: 'Parestesia de braços (Formigamento)',
              des:
                'A compressão do nervo cervical também pode causar dormência ou parestesia dos braços.'
            }
          ]
        }
      ],
      trunk: [
        {
          name: 'Escoliose',
          key: 'spineSidesway',
          normal: {
            left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition:
            '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des:
              '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [
            {
              name: 'Escoliose',
              des:
                'É indicada uma inspeção 3-D ou um raio x panorâmico para diagnosticar a escoliose.'
            },
            {
              name: 'Ombros desalinhados',
              des: ' A escoliose pode ser acompanhada de ombros desalinhados.'
            },
            {
              name: 'Quadril desalinhado',
              des: ' A escoliose pode ser acompanhada por quadril desalinhados.'
            }
          ]
        }
      ],
      pelvis: [
        {
          name: 'Quadril desalinhado',
          key: 'pelvisLean',
          normal: {
            left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition:
            '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle:
              '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des:
              '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [
            {
              name: 'Dor crônica',
              des: 'Quadril desalinhados, pode causar dor nas extremidades.'
            },
            {
              name: 'Hérnia de disco lombar',
              des:
                'Quadril desalinhado, pode aumentar o risco de hérnia de disco lombar.'
            },
            {
              name: 'Discrepância do comprimento da perna',
              des:
                'Quadril desalinhado pode aumentar o risco de discrepância no comprimento das pernas.'
            }
          ]
        }
      ],
      'lower extremity': [
        {
          name: 'Joelho varo',
          key: 'legO',
          normal: {
            normal: imgSrc.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_O
          },
          definition:
            '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des:
              '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [
            {
              name: 'Lesão menisco',
              des:
                ' A força no membro inferior dos indivíduos com pernas arqueadas é alterada para que '
            },
            {
              name: 'Artrite',
              des:
                'Perna severamente arqueadas podem eventualmente evoluir para osteoartrite no espaço intersticial lateral da articulação.'
            }
          ]
        },
        {
          name: 'Genu Valgum',
          key: 'legX',
          normal: {
            normal: imgSrc.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle:
              '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des:
              '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [
            {
              name: 'Lesão de menisco',
              des:
                'Como os joelhos valgos alteram a direção da força no membro inferior, o joelho está sujeito a aumento da pressão lateral. Resultando geralmente em lesões e distensão lateral do menisco.'
            },
            {
              name: 'Artrite',
              des:
                'Genu valgum grave pode eventualmente progredir para osteoartrite.'
            }
          ]
        },
        {
          name: 'genu recurvatum',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition:
            '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle:
              '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des:
              '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [
            {
              name: 'Degeneração da articulação do joelho',
              des:
                'O desgaste excessivo e a degeneração do joelho são o resultado de persistentes dores nas costas.'
            },
            {
              name: 'Influência do equilíbrio corporal',
              des:
                'Os joelhos deformados levam a mudanças de posição dos quadril, pelve e tornozelos, e podem gradualmente modificar o equilíbrio de todo o corpo.'
            }
          ]
        },
        {
          name: 'Arco falso de pernas',
          key: 'legXO',
          normal: {
            normal: imgSrc.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des:
              'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [
            {
              name: 'Dor no joelho',
              des:
                `Quando a pélvica se inclina para a Coronal, cria também um desalinhamento da 'grade' na articulação do joelho. Agora, seu fêmur não encaixa adequadamente na sua tíbia (osso da canela), criando um desequilíbrio. Quando o desequilíbrio é combinado com rotação interna do fêmur (devido à falta de glúteos fortes por causa do APT), você acaba com uma receita perfeita para falsas curvaturas dos joelhos.  n ` +
                'você pode ouvir o joelho estalando, rangindo com bastante frequência enquanto se movimenta ao longo do dia. '
            },
            {
              name: 'Artrite',
              des:
                'À medida que o tempo avança, você pode começar a sentir dor, já que as estruturas estabilizadoras (cartilagem e ligamentos) do joelho, são desgastadas a uma taxa muito mais rápida, em comparação com um joelho neutro..'
            }
          ]
        }
      ]
    }
  },
  sympItem: {
    levelName: 'Alto | Médio | Baixo'
  },
  sympItemIpad: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco Médio',
    heightRisk: 'Risco Alto',
    suggest:
      'Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis',
    suggestSolve:
      'Você realmente precisam melhorar sua postura, procure um fisioterapeuta especialista em quiropraxia, osteopatia ou podoposturologia para fazer melhor avaliá-la',
    normal: 'Normal',
    risk: 'Risco',
    levelName: 'Alto | Médio | Baixo'
  }
}

export { pt }



// WEBPACK FOOTER //
// ./src/assets/lang.conf/pt.js